module.exports = __webpack_public_path__ + "static/img/yiwu.398077b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/yiwu.png
// module id = Vscf
// module chunks = 1